// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Products Page New - Full Screen Sections */

.products-page-new {
  width: 100%;
  overflow-x: hidden;
}

.products-page-new > div {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  scroll-snap-align: start;
  scroll-behavior: smooth;
}

/* Loading Container */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
}

.loading-spinner {
  font-size: 1.5rem;
  color: #333;
  font-weight: 500;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* No Products Container */
.no-products-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
}

.no-products-container p {
  font-size: 1.5rem;
  color: #666;
  text-align: center;
}

/* Diced Hero Section Overrides */
.products-page-new main {
  padding: 6rem 2rem 3rem 2rem !important;
  min-height: 100vh;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .products-page-new main {
    padding: 6rem 1.5rem 2rem 1.5rem !important;
    min-height: auto;
    height: auto;
  }

  .products-page-new main > div:first-child {
    flex: 1 1;
    max-width: 100% !important;
  }

  .products-page-new main > div:last-child {
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (max-width: 768px) {
  .products-page-new main {
    padding: 5rem 1rem 1.5rem 1rem !important;
  }

  .products-page-new main > div:first-child {
    max-width: 100% !important;
    padding-bottom: 1.5rem !important;
  }
}

/* Text sizing adjustments */
.products-page-new h1 {
  word-break: break-word;
}

.products-page-new p {
  word-break: break-word;
}

/* Image grid adjustments */
.products-page-new .warped-image {
  transition: transform 0.3s ease-in-out;
}

.products-page-new .warped-image:hover {
  transform: scale(1.05);
}

/* Button styling */
.chronicleButton {
  font-size: 1rem;
  transition: all 0.3s ease-in-out;
}

/* Scroll snap for full-screen sections */
html {
  scroll-behavior: smooth;
}

/* Smooth transitions between sections */
.products-page-new > div {
  transition: background-color 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/styles/products-page-new.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,uCAAuC;EACvC,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,SAAO;IACP,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,sCAAsC;AACxC","sourcesContent":["/* Products Page New - Full Screen Sections */\n\n.products-page-new {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.products-page-new > div {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  scroll-snap-align: start;\n  scroll-behavior: smooth;\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);\n}\n\n.loading-spinner {\n  font-size: 1.5rem;\n  color: #333;\n  font-weight: 500;\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* No Products Container */\n.no-products-container {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);\n}\n\n.no-products-container p {\n  font-size: 1.5rem;\n  color: #666;\n  text-align: center;\n}\n\n/* Diced Hero Section Overrides */\n.products-page-new main {\n  padding: 6rem 2rem 3rem 2rem !important;\n  min-height: 100vh;\n  width: 100% !important;\n  max-width: 100% !important;\n  margin: 0 !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .products-page-new main {\n    padding: 6rem 1.5rem 2rem 1.5rem !important;\n    min-height: auto;\n    height: auto;\n  }\n\n  .products-page-new main > div:first-child {\n    flex: 1;\n    max-width: 100% !important;\n  }\n\n  .products-page-new main > div:last-child {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .products-page-new main {\n    padding: 5rem 1rem 1.5rem 1rem !important;\n  }\n\n  .products-page-new main > div:first-child {\n    max-width: 100% !important;\n    padding-bottom: 1.5rem !important;\n  }\n}\n\n/* Text sizing adjustments */\n.products-page-new h1 {\n  word-break: break-word;\n}\n\n.products-page-new p {\n  word-break: break-word;\n}\n\n/* Image grid adjustments */\n.products-page-new .warped-image {\n  transition: transform 0.3s ease-in-out;\n}\n\n.products-page-new .warped-image:hover {\n  transform: scale(1.05);\n}\n\n/* Button styling */\n.chronicleButton {\n  font-size: 1rem;\n  transition: all 0.3s ease-in-out;\n}\n\n/* Scroll snap for full-screen sections */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Smooth transitions between sections */\n.products-page-new > div {\n  transition: background-color 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
